import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageService } from '../language.service';
import { WhatsappService } from '../whatsapp.service';
import { LoginService } from '../login.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-send-whatsapp-dialog',
    templateUrl: './send-whatsapp-dialog.component.html',
    styleUrls: ['send-whatsapp-dialog.component.scss'],
    standalone: false
})
export class SendWhatsappDialogComponent implements OnInit {
  GeneralMsgTemplateHeader;
  GeneralMsgTemplateFooter;

  constructor(
    public dialogRef: MatDialogRef<SendWhatsappDialogComponent>,
    public lang: LanguageService,
    public whatsappService: WhatsappService,
    public ls: LoginService,
    @Inject(MAT_DIALOG_DATA) public patient: any,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) { }

 async ngOnInit(): Promise<any> {
    await this.setClinicMsgTemplate();
  }

  closeDialog() {
    this.dialogRef.close();
  }
  async sendWhatsapp(message: string) {
    let first = this.patient.First;
    let last = this.patient.Last;
    let mobile = this.patient.Mobile;
    let id = this.patient.ID;
    try {
      let addmsg = await this.whatsappService.sendWhatsappGeneral(first, last, mobile, id, this.ls.username, this.sanitizeInput(message));
      if (addmsg['status'] === 'ok') {
        // Close the dialog when status is 'ok'
        this.snackBar.open(this.translate.instant('messages.pat-comp-msgsuccess-feedback'), this.translate.instant('messages.pat-comp-msg-close'), {
          duration: 3000,
          direction: this.lang.getPageDirection() === 'rtl' ? 'rtl' : 'ltr'
        });
        this.dialogRef.close();
      } else {
        let snackBarRef = this.snackBar.open(this.translate.instant('messages.pat-comp-msgfail-feedback'), this.translate.instant('messages.pat-comp-msg-retry'), {
          duration: 8000,
          direction: this.lang.getPageDirection() === 'rtl' ? 'rtl' : 'ltr'
        });
        snackBarRef.onAction().subscribe(async() => {
         await this.sendWhatsapp(this.sanitizeInput(message));
        });
      }
    } catch (error) {
      console.error('Error adding new message:', error);
      let snackBarRef = this.snackBar.open(this.translate.instant('messages.pat-comp-msgfail-feedback'), this.translate.instant('messages.pat-comp-msg-retry'), {
        duration: 8000,
        direction: this.lang.getPageDirection() === 'rtl' ? 'rtl' : 'ltr'
      });
      // When "Retry" is clicked, call sendMessage() again.
      snackBarRef.onAction().subscribe(async() => {
       await this.sendWhatsapp(this.sanitizeInput(message));
      });
    }
  }
  async setClinicMsgTemplate() {
    let getMsgTemplate: any = await this.whatsappService.getClinicMsgTemplate();
    if (getMsgTemplate.GID) {
      this.GeneralMsgTemplateHeader = getMsgTemplate.header;
      this.GeneralMsgTemplateFooter = getMsgTemplate.footer;
    }
  }
  sanitizeInput(input: string): string {
    // Replace all tab characters with a single space
    let output = input.replace(/\t/g, ' ');
    // Replace newlines and carriage returns with a single space
    output = output.replace(/(\r\n|\n|\r)/g, ' ');
    // Replace sequences of 4 or more spaces with 3 spaces (adjust if needed)
    output = output.replace(/ {4,}/g, '  ');
    // Optionally trim leading or trailing spaces if desired
    return output.trim();
  }
}
